import { useContext, useState } from "react";
import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { offerwallapi } from "../../config/axiosconfig";
import { ClientContext } from "../../context/client/ClientContext";
import { LanguageContext } from "../../context/language/LanguageContext";
import { TenantContext } from "../../context/tenant/TenantContext";
import Cookies from "universal-cookie";

export default function Verify() {
  const clientToken = useLocation().pathname.split("verify/")[1];

  const [message, setMessage] = useState("");
  const { tenant } = useContext(TenantContext);
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);

  const { client, clientError, clientdispatch } = useContext(ClientContext);

  const params = useParams();
  const tenanturl = params.tenanturlpathname;
  const verifytoken = params.verifytoken;
  const campaignid = params.campaignid;
  const ischange = params.emailchange;


  useEffect(() => {
    const verify = async () => {
      try {
        if (campaignid) {
          if (!client) {
            navigate(`/${tenanturl}/signin`);
          } else {
            navigate(`/${tenanturl}/gamification`, {
              state: { campaignId: campaignid },
            });
          }
        } else if (!client) {
          clientdispatch({ type: "OFFERS_START" });
          const endpoint = campaignid
            ? "clientmagicverification"
            : "clientverification";
          const res = await offerwallapi.post(`/api/clients/${endpoint}`, {
            clienttoken: encodeURIComponent(verifytoken),
            clienttenantid: tenant.tenantid,
            ischange
          });

          if (res.status === 202 || res.status === 201) {
            // res.data.isenrolled = true;
            clientdispatch({ type: "CLIENT_SUCCESS", payload: res.data });
            setMessage(language?.success_res.success_l6);
            const cookies = new Cookies();
            let dtn = new Date();
            cookies.set("campaign_ref", "", {
              path: "/",
              expires: new Date(dtn.setMinutes(dtn.getMinutes() - 30)),
              secure: true,
              domain: ".offers-exchange.com",
            })
            setTimeout(function () {
              if (campaignid) {
                navigate(`/${tenanturl}/gamification`, {
                  state: { campaignId: campaignid },
                });
              } else {
                if (res.data.isenrolled) {
                  navigate(`/${tenanturl}`);
                } else {
                  navigate(`/${tenanturl}/user/mycards`);
                }
              }
            }, 2500);
          } else if (res.status === 200) {
            clientdispatch({ type: "CLIENT_FAIL", payload: "ERROR" });

            if (campaignid) {
              setTimeout(function () {
                navigate(`/${tenanturl}/signin`);
              }, 2500);
            } else {
              setMessage(language?.error_res.error_l4);
              setTimeout(function () {
                navigate(`/${tenanturl}`);
              }, 2500);
            }
          }
        } else {
          setTimeout(function () {
            if (client?.isenrolled) {
              navigate(`/${tenanturl}`);
            } else {
              navigate(`/${tenanturl}/user/mycards`);
            }
          }, 2500);
        }
      } catch (err) {
        clientdispatch({ type: "CLIENT_FAIL", payload: "ERROR" });

        if (campaignid) {
          setTimeout(function () {
            navigate(`/${tenanturl}/signin`);
          }, 2500);
        } else {
          setMessage(language?.error_res.error_l3);
          setTimeout(function () {
            navigate(`/${tenanturl}`);
          }, 2500);
        }
      }
    };
    if (tenant && language) verify();
  }, [language, tenant, client]);

  return (
    <div className="ow-full-overlay">
      <div className="position-absolute ow-content-center text-center">
        <Spinner animation="border" backdrop="static" variant="light" />
        <h3 className="text-light">{message}</h3>
      </div>
    </div>
  );
}
